// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';

// import '@/libs/rem';
import './styles/main.scss';
import 'animate.css'; // 引入animate动画
// import * as http from '@/libs/api';
// import httpsRequest from '@/libs/request';
// import '@/plugins/element-ui.js';
// import store from '@/store/store.js';
// import query from '@/utils/query';

// Vue.prototype.$http = http; // ajax请求方法
// Vue.prototype.$query = query;
// Vue.prototype.$http = httpsRequest  // ajax请求方法

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: {App},
	template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js